/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャット画面起動用JS
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import langJa from 'element-ui/lib/locale/lang/ja'
import langEn from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/icon.css'
import App from './App'
import axios from 'axios'
import WindowUtil from '@/utils/WindowUtil'
import FastchatStateManager from '@/utils/FastchatStateManager'
import MessageInfoConst from '@/constants/MessageInfoConst'
import VueVisible from 'vue-visible'

Vue.use(VueVisible)

Vue.config.productionTip = false

Vue.use(Vuex)

Vue.use(vuexI18n.plugin, new Vuex.Store())
Vue.i18n.add('en', require('./assets/translations/translationsEn.json'))
Vue.i18n.add('ja', require('./assets/translations/translationsJa.json'))

axios.get('./service/findFastchatWindowSetting')
  .then((res) => {
    // 設定情報
    const configData = JSON.parse(res.data.fastchatWindowSettingJson)
    configData.serviceServer = configData.serviceServer || './service'
    configData.chatServer = configData.chatServer || '../../../chat/ws'
    configData.lang = configData.lang || 'ja'
    configData.parentOrigin = configData.parentOrigin || '*'
    configData.availableChatConnectionIntervalTime = configData.availableChatConnectionIntervalTime || 60000
    configData.fhMessageTypingLabelFadeoutTime = configData.fhMessageTypingLabelFadeoutTime || 6000
    configData.fcMessageTypingSendIntervalTime = configData.fcMessageTypingSendIntervalTime || 5000
    configData.webFormParentPath = res.data.webFormParentPath || '../../web'
    configData.webFormSettingId = res.data.webFormSettingId || null
    configData.surveyWindowConfig = configData.surveyWindowConfig || {
      useSurveyWindow: false
    }
    configData.surveyWindowConfig.surveyCommentTextMaxLength = configData.surveyWindowConfig.surveyCommentTextMaxLength || 2000
    configData.confirmMessage = configData.confirmMessage || {}
    configData.confirmMessage.answerList = configData.confirmMessage.answerList || [{
      id: 0,
      label: configData.lang === 'ja' ? 'はい' : 'Yes'
    }, {
      id: 1,
      label: configData.lang === 'ja' ? 'いいえ' : 'No'
    }]
    configData.switchConfirmMessage = configData.switchConfirmMessage || {}
    configData.switchConfirmMessage.answerList = configData.switchConfirmMessage.answerList || [{
      id: 0,
      label: configData.lang === 'ja' ? 'はい' : 'Yes',
      confirmType: MessageInfoConst.CONFIRM_TYPE_SWITCH_MANUAL,
      labelSynonym: ['はい', 'YES', 'Yes', 'yes', 'ok', '1'],
      waitChatReceive: true
    }, {
      id: 1,
      label: configData.lang === 'ja' ? 'いいえ' : 'No',
      confirmType: MessageInfoConst.CONFIRM_TYPE_SWITCH_MANUAL,
      labelSynonym: ['いいえ', 'NO', 'No', 'no', 'ng', '2']
    }]
    configData.suggestIntarval = configData.suggestIntarval || 1000

    if (WindowUtil.getQueryParamObject()['testMode'] === 'true') {
      configData._testMode = true
    }

    configData.sendImageFileFlg = configData.sendImageFileFlg || false
    configData.sendVideoFileFlg = configData.sendVideoFileFlg || false
    configData.sendFileFlg = configData.sendFileFlg || false
    configData.sendImageFileExtension = configData.sendImageFileExtension
    configData.sendVideoFileExtension = configData.sendVideoFileExtension
    configData.sendFileExtension = configData.sendFileExtension
    configData.sendFileMaxSize = configData.sendFileMaxSize || 2
    configData.sendFileNameMaxByteLength = configData.sendFileNameMaxByteLength || 512
    configData.userPolicyDisplayConfig = configData.userPolicyDisplayConfig || {}
    configData.customerInputFormConfig = configData.customerInputFormConfig || {}
    if (configData.useChatJoinDisplay == null) {
      configData.useChatJoinDisplay = true
    }
    if (configData.customerInputFormConfig.useWebUserInfo) {
      configData.useWebUserInfo = configData.customerInputFormConfig.useWebUserInfo
    }

    const splitPath = location.href.split('/')
    configData['_fastchatWindowSettingId'] = Number(splitPath[splitPath.length - 2])
    Vue.use(require('vue-config'), configData)
    Vue.prototype.$config = configData

    // ロケール設定
    const lang = configData.lang
    // Element-ui部品のロケール設定
    if (lang === 'en') {
      locale.use(langEn)
    } else {
      locale.use(langJa)
    }
    // 翻訳メッセージのロケール設定
    Vue.i18n.set(lang)

    let isServiceAccess = false
    axios.get('./service/checkServiceAccess').then(_ => {
      isServiceAccess = true
    }).finally(_ => {
      // initializedFastchatFrame処理
      WindowUtil.addMessageEventListener('initializedFastchatFrame', function (event) {
        const supplementConfigData = event.data.supplementConfigData
        if (isServiceAccess && !FastchatStateManager.isAlwaysSeparateChatWindow()) {
          configData['_alwaysSeparateChatWindow'] = supplementConfigData['alwaysSeparateChatWindow']
        } else {
          configData['_alwaysSeparateChatWindow'] = true
        }
      }, true)
      // チャット画面起動
      /* eslint-disable no-new */
      const vueApp = new Vue({
        el: '#app',
        components: {
          App
        },
        template: '<App/>'
      })
      // フレーム初期化メッセージを送信
      WindowUtil.postInitFastchatFrameMessageToParent(configData.fastchatFrameConfig)
      // 「チャット開始」メッセージハンドラ
      WindowUtil.addMessageEventListener('chatStart', function (event) {
        vueApp.$children[0].chatStart()
      }, false)
    })
  })
  .catch((res) => {
    console.error(res)
  })



// WEBPACK FOOTER //
// ./src/main.js